var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStackedColumn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#81848F",
  d: "M1 23h23v1H0V0h1z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 2)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4569A5",
  d: "M0 11.5h5V19H0zm7-5h5V19H7zM14 9h5v10h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#97C2EA",
  d: "M0 8h5v3H0zm7-8h5v6H7zm7 3.5h5v5h-5z"
})))));
export default SvgStackedColumn;